/**
 * The call categories the SPA filters on — derived from `callCategorySchema`,
 * never restated.
 *
 * This used to be a hand-written copy of the same twelve values, and the two
 * had already drifted on ORDER after `ANALYZED_CALL_CATEGORIES` was reordered.
 * Order is the harmless half: the next category added to the enum ships to the
 * API and the analyzer while the SPA silently ignores it — `RecordsPage` drops
 * an unrecognized `?callCategory=` from a dashboard drill-down link (leaving
 * the filter on its previous value, with no error) and `UnifiedFilterBar` never
 * offers the option. Importing the enum makes that impossible.
 */
import { callCategorySchema, type CallCategory } from '@aica/api-types';

export const CALL_CATEGORY_OPTIONS = callCategorySchema.options;

export type CallCategoryOption = CallCategory;

/**
 * A call the product treats as short: the `isShortCall` flag OR the `short`
 * category. Bitrix24 stores its sub-15-second calls with only the category
 * (`is_short_call = false`), so the flag alone keeps the shortest calls in. The
 * list's «hide short calls» filter applies the same rule on the server
 * (`notShortCallCondition` in `@aica/database`); this is its mirror for rows
 * the page filters itself, such as the semantic search results.
 */
export function isShortCallRecord(record: {
  isShortCall?: boolean | null;
  callCategory?: string | null;
}): boolean {
  return record.isShortCall === true || record.callCategory === 'short';
}
